import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { TableSearchInput } from "components/common/input";
import { AddBtn } from "components/common/button";
import { RecommendListTable, RecommendAddModal } from "components/recommend";
import { PrimayPagination } from "components/common/pagination";
import type { IRecommendList } from "service/interface/burial";

export function RecommendListPage() {
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{
    count: number;
    data: IRecommendList[];
  }>({ count: 0, data: [] });
  const [isAddModalVisible, setIsAddModalVisible] = useState<boolean>(false);

  const { data, mutate } = useSWR(
    `/admin/manage/recommend/park?limit=12&offset=${
      selectPage * 12 - 12
    }&search=${searchValue}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handleAddBtn = () => {
    setIsAddModalVisible(true);
  };

  return (
    <>
      <RecommendAddModal
        isVisible={isAddModalVisible}
        setIsVisible={setIsAddModalVisible}
        mutate={mutate}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
            추천 리스트
          </p>
          <div className="mb-[24px] mt-[16px] flex items-center justify-between">
            <TableSearchInput
              value={searchValue}
              setValue={setSearchValue}
              placeholder="키워드로 검색해 주세요."
            />
            <AddBtn onClick={handleAddBtn} />
          </div>
          <RecommendListTable data={listData.data} mutate={mutate} />
          <div className="mt-[32px] flex justify-end">
            <PrimayPagination
              listLength={Math.ceil(listData.count / 12)}
              pageNumber={selectPage}
              setPageNumber={setSelectPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
